import Vue from 'vue';

import i18n from '@/libs/i18n';
import store from '@/libs/store';
import router from '@/libs/router';

import '@/libs/axios';
import '@/libs/dayjs';
import '@/libs/quasar';

import '@/libs/plugins';
import '@/libs/constants';
import '@/libs/directives';
import '@/libs/helpers';
import '@/libs/components';

import App from '@/App.vue';

Vue.config.productionTip = false;

new Vue({
    i18n,
    router,
    store,
    render: h => h(App),
}).$mount('#app');
